<template>
    <CCard >    
      <CCardBody>  
          <div id='app' style="height:700px">
            <div id='container' style="height:700px">
                <ejs-schedule locale='zh-Hans-HK' id="schedule" field='OwnerId'  ref="ScheduleObj" height='700px' width='100%' :dateFormat='dateFormat' :cssClass="cssClass" :selectedDate='selectedDate' :views='views' :eventSettings='eventSettings' 
                  :actionBegin='onActionBegin' :eventRendered="onEventRendered" :popupOpen="onPopupOpen"  :currentView="currentView" colorField='CategoryColor' :allowResizing="false" :actionComplete="onActionComplete" :agendaDaysCount="7">
                  <e-views>
                    <e-view option='Day'></e-view>
                    <e-view option='Week' ></e-view>
                    <e-view option='WorkWeek'></e-view>
                    <e-view option='Month'></e-view>
                    <e-view option='Agenda'></e-view>
                  </e-views>
                </ejs-schedule>
                <ejs-dialog ref="SerchDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' header="查詢成品編號" :buttons='e_seach_buttons' width='500px'>
                  <ejs-dropdownlist :dataSource='productDatas'  allowObjectBinding='true' showClearButton="true" :allowFiltering='true' v-model="e_findformula_id" :fields='dropDownFields'  ></ejs-dropdownlist>
                </ejs-dialog>
                <ejs-dialog ref="calendarDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' :header='e_edit_id == null ? e_selected_date + "建立生產排程" : e_selected_date + "修改生產排程" ' :buttons='e_calendar_buttons' 
                    width='700px'>
                    <div formGroup="orderForm">          
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <div class="alert alert-primary" role="alert">
                              建立生產排程,選擇配方後輸入總量,系統將會自動計算領料及加總。 
                            </div>
                          </div>
                          <div class="form-group col-md-6"> 
       
                            <span class="about-title-verify">配方編號</span> 
                            <ejs-dropdownlist :dataSource='formulalDatas'  allowObjectBinding='true' showClearButton="true" :allowFiltering='true' v-model="e_formula_id" :change='onFormulalChange' :fields='dropDownFields'  ></ejs-dropdownlist>
                          </div>                         
                          <div class="form-group col-md-6">
                            <span class="about-title-verify">生產總量 - </span>  <span style="text-align: right; color: blue;">已配置總量: {{ totalL }}L</span>
                            <ejs-numerictextbox id="total" format='#####L' v-model="e_productionL" floatLabelType="Auto" :enabled="e_formula_id != null" :step="100" :min="0" :max="20000" :fields='dropDownFields' ></ejs-numerictextbox>
                           
                          </div>  
                          <div class="form-group col-md-12">
                            <span class="about-title-verify">成品編號</span> 
                            <ejs-multiselect  ref="multiselect" id="multiselect" v-model='productvalue' :enabled="e_productionL !=0" :dataSource="productDatas" :allowFiltering="true"
                                @blur="updateSelected" :fields='MultiselectFields'></ejs-multiselect>
                          </div> 
                        </div>                       
                        <div v-for="(item, index) in selectedTexts" :key="index">
                          <div class="form-row">
                            <div class="form-group col-md-7">
                              <span class="about-title-verify">{{item.text}} - </span> 
                              <span style="text-align: right; color: blue;"> {{ item.param == null ? "無係數可轉換,請至配方表設定" : `1個成品可轉換${item.param}L` }}</span>
                            <ejs-numerictextbox 
                              format="####.##L"
                              v-model="item.liter"                            
                              floatLabelType="Auto"
                              @change="updateLiter($event, index)"
                              :step="100"
                              :min="0"
                              :max="20000">
                            </ejs-numerictextbox>                          
                           
                            </div>
                            <div class="form-group col-md-4">
                              <span class="about-title-verify">成品數量</span> 
                              <ejs-numerictextbox 
                                format="####/成品數量" v-model="item.quity" floatLabelType="Auto" @change="updateQuity($event, index)" :showSpinButton="false">
                              </ejs-numerictextbox>
                            </div>
                            <div class="form-group col-md-1">
                              <span class="about-title-verify">順序</span> 
                              <ejs-numerictextbox 
                                format="##" v-model="item.orderby" floatLabelType="Auto" :showSpinButton="false">
                              </ejs-numerictextbox>
                            </div>
                          </div>
                        </div>
                      
                        <div class="form-row">
                          <div class="form-group col-md-7">
                            <div class="row">
                              <div class="col-md-6">
                                <span class="about-title-verify">備註</span>
                              </div>                             
                            </div>
                            <ejs-textbox ref="textareaObj" id="default" :multiline="true" v-model="e_memo"></ejs-textbox>
                          </div>
                          <div class="form-group col-md-5">
                            <span class="about-title-verify">重要性</span>
                            <div style="padding-left: 20px; padding-top: 20px;">                             
                              <ejs-radiobutton  label="低" name="import" value="low" :checked="e_import == 1" :change="radiobuttonImportChange"></ejs-radiobutton>&nbsp; 
                              <ejs-radiobutton label="中" name="import" value="med" :checked="e_import == 2"  :change="radiobuttonImportChange"></ejs-radiobutton>&nbsp;
                              <ejs-radiobutton label="高" name="import" value="high" :checked="e_import == 3"  :change="radiobuttonImportChange"></ejs-radiobutton>                      
                            </div>    
                          </div>
                        </div>   
                          
                    </div>                
                </ejs-dialog>
                <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
            </div>
          </div>
      </CCardBody>
    </CCard>
      
    </template>
    <script>
    import Vue from 'vue';   
    import Loading from 'vue-loading-overlay';
    import zhtwLocalization  from '../language/language.json';
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { MultiSelectComponent } from '@syncfusion/ej2-vue-dropdowns';
    import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
    import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
    import { ToastComponent, } from "@syncfusion/ej2-vue-notifications";
    import { L10n, loadCldr , setCulture} from '@syncfusion/ej2-base';
    import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import frNumberData from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/numbers.json';
    import frtimeZoneData from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/timeZoneNames.json';
    import frGregorian from '@syncfusion/ej2-cldr-data/main/zh-Hans-HK/ca-gregorian.json';
    import frNumberingSystem from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
    import { SchedulePlugin, Day, Week, TimelineViews, Month, Agenda, Resize, DragAndDrop, ExcelExport } from '@syncfusion/ej2-vue-schedule';

  
    Vue.use(SchedulePlugin);
    Vue.use(Loading);
    Vue.use(DialogPlugin);
    Vue.use(RadioButtonPlugin);
    L10n.load(zhtwLocalization);
    loadCldr(frNumberData, frtimeZoneData, frGregorian, frNumberingSystem);
    setCulture('zh-Hans-HK');

    let DialogObj   = undefined;
    let Loader      = undefined;

    export default {
      components: {
        'ejs-toast': ToastComponent,
        "ejs-dropdownlist": DropDownListComponent,
        "ejs-numerictextbox": NumericTextBoxComponent,
        'ejs-multiselect': MultiSelectComponent,
        // 'ejs-button': ButtonComponent,
        // 'ejs-timepicker': TimePickerComponent 
      },
      data (){
        return {
          // 共用
          limit : localStorage.getItem('production'), 
          dropDownFields: { text: 'text', value: 'value' },
          position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
          e_findformula_id:null,
          // Dialog
          MultiselectFields: { value: 'value', text: 'text' },
          productvalue:null,
          selectedTexts: [],
          formulalDatas: null, productDatas: null,
  
          e_memo: null,
          e_edit_id: null, e_import: null,
          e_formula_id: null, 
          e_productionL: null,
          e_calendar_buttons: [
            {click: this.dialog_editOkClick, buttonModel: { content: '刪除', isPrimary: true, disabled: localStorage.getItem('production').indexOf('12') <= 0 }},
            {click: this.addCalendarOkClick, buttonModel: { content: '送出', isPrimary: true, disabled: localStorage.getItem('production').indexOf('12') <= 0 }}, 
            {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}],
          e_seach_buttons: [
            {click: this.SelectAddButton, buttonModel: { content: '送出', isPrimary: localStorage.getItem('production').indexOf('12') <= 0 }}, 
            {click: this.SelectCencelButton,buttonModel: { content: '取消', isPrimary: false}}],
          e_selected_date: null,
          cssClass: 'excel-export',       
          views: ['TimelineDay', 'Day', 'Week', 'Month', 'Agenda'],
          dateFormat: 'yyyy-MM-dd',          
          currentView: 'Month',
          eventSettings: null, 
          selectedDate: Date.now(),
          totalL:0
        }
      },
      methods: {
        //查詢按鈕
        SelectDeail:function(){
          this.$refs.calendarDialog.hide();
          this.$refs.SerchDialog.show();
          this.onFormulalChange("all");
        },
        SelectCencelButton:function(){
          this.$refs.calendarDialog.show();
          this.$refs.SerchDialog.hide();
          this.onFormulalChange();
        },
        SelectAddButton:function(){
          if(this.e_findformula_id == null){
            alert("請輸入品號")
            return;
          }
          this.$refs.calendarDialog.show();
          this.$refs.SerchDialog.hide();
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar/FindFormula?Product_id=${this.e_findformula_id}`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
            const data =  response.data.datas.value;
            
            this.e_formula_id = data; 
            this.$nextTick(() => {
              this.productvalue=[this.e_findformula_id];
              this.$nextTick(() => {
              this.updateSelected();
            });
            });
          })
          .catch((error) => { 
            this.showError(error, true) }
          )             
        },
        onFormulalChange: function (args) {
          let formulaId = this.e_formula_id;
          if(args == "all"){
            formulaId = "null";
          }
          return this.axios({
            method: 'get',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/Calendar/Product?formula_id=${formulaId}`,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
          })
          .then((response) => {
            if (!response.data.ok) {
              this.$refs.toastRef.show({ /* ... */ });
              return;
            }
            this.productDatas = response.data.datas;
            this.$nextTick(() => {
              if (this.$refs.multiselect?.ej2Instances) {
                this.$refs.multiselect.ej2Instances.dataSource = this.productDatas;
                this.$refs.multiselect.ej2Instances.refresh();  
              }
            });
          });
        },
        upDateTime:function(args){
          this.showLoading();
          this.axios({
              method: 'put',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar/Time`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
              data : {
                  id :args.Id,
                  StartTime:args.StartTime,
                  EndTime:args.EndTime
              }
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading();this.getCalendar();  return; }              
            this.showMsg('日期修改成功!');         
            this.$refs.calendarDialog.hide();
            this.hideLoading();
            this.getCalendar();  
          
          })
          .catch((error) => { 
            this.showError(error, true) }
          )    
        },
        updateSelected() {
          const selectedValues = this.$refs.multiselect.ej2Instances.value;
          // 檢查是否有空值
          
          if (!selectedValues || selectedValues.some(val => !val)) {
            return;
          }
          
          let selectedItems = this.$refs.multiselect.ej2Instances.value.map(id=>
          this.$refs.multiselect.ej2Instances.getDataByValue(id));
          this.selectedTexts = selectedItems;
          console.log("selectedItems:",selectedItems)
          console.log("e_formula_id:",this.e_formula_id)
          if (this.e_formula_id == null) {
             this.e_formula_id = selectedItems[0].formula_id;
          }
        },
        updateQuantity(event, index) {
            this.selectedTexts[index].quantity = event.value;

            const total = this.selectedTexts
              .slice(0, -1) // 排除最後一筆
              .reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);
          this.totalL=this.selectedTexts
              .reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);
            if (total > this.e_productionL) {
              return;
            }

            const remaining = this.e_productionL - total;
            const lastIndex = this.selectedTexts.length - 1;

            // 如果你不是正在編輯最後一筆，才去自動補上最後一筆
            if (index !== lastIndex) {
              const currentLast = parseFloat(this.selectedTexts[lastIndex].quantity) || 0;
              if (currentLast !== remaining) {
                this.selectedTexts[lastIndex].quantity = remaining;
              }
            }
        },
          
        updateLiter(event, index) {
          
            this.selectedTexts[index].liter = Math.ceil(event.value);
            
            // console.log("event.value:",event.value)
            this.selectedTexts[index].quity = parseInt(event.value / this.selectedTexts[index].param);
            // console.log("event.value / this.selectedTexts[index].param;:",event.value / this.selectedTexts[index].param)
            const total = Math.ceil(
              this.selectedTexts
                .slice(0, -1) // 排除最後一筆
                .reduce((sum, item) => sum + (parseFloat(item.liter) || 0), 0)
            );
             
            this.totalL = this.selectedTexts

                .reduce((sum, item) => sum + (parseFloat(item.liter) || 0), 0);
            if (total > this.e_productionL) {
              return;
            }

            const remaining = this.e_productionL - total;
            const lastIndex = this.selectedTexts.length - 1;
           
            // 如果你不是正在編輯最後一筆，才去自動補上最後一筆
            if (index !== lastIndex) {
              const currentLast = parseFloat(this.selectedTexts[lastIndex].liter) || 0;
              if (currentLast !== remaining) {
                this.selectedTexts[lastIndex].liter = remaining;
              }
            }
          },
        updateQuity(event, index) {            
            this.selectedTexts[index].liter = event.value * this.selectedTexts[index].param;
            
        },
        dialog_editOkClick:function(){
          if( this.selectedTexts.reduce((sum, item) => sum + (item.liter || 0), 0) == this.e_productionL){
            // 新增
            this.$refs.calendarDialog.hide();
          }
          else{
            this.$refs.toastRef.show({ title: '警告!', content : `總量為${this.e_productionL}L,但僅配${ this.selectedTexts.reduce((sum, item) => sum + (item.liter || 0), 0)}L`, cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
          }
        },
        radiobuttonImportChange: function(args) {   
          if (args.value == "low") this.e_import = 1;
          if (args.value == "med") this.e_import = 2;
          if (args.value == "high") this.e_import = 3;
        }, 
        getDateTime:function (dt) {
          return `${dt.getFullYear()}-${this.pad2(dt.getMonth() + 1)}-${this.pad2(dt.getDate())}T${this.pad2(dt.getHours())}:${this.pad2(dt.getMinutes())}:${this.pad2(dt.getSeconds())}.000Z`
        },
        getDate:function (dt) {
          return `${dt.getFullYear()}-${this.pad2(dt.getMonth() + 1)}-${this.pad2(dt.getDate())}`
        },
        pad2:function (n) { 
          return (n < 10 ? '0' : '') + n;
        },
        onPopupOpen: function (args) {
          args.cancel = true;     
          //取得事件開始時間
          let eventStart = args.data.StartTime || args.data[0]?.StartTime;
          let today = new Date();
          today.setHours(0, 0, 0, 0); //把今天的時間歸零，只比日期
          console.log(args.data.Id)
          //如果是今天以前的事件，阻止操作
    
          if (args.data.Id != null){
            //修改
            this.e_edit_id = args.data.Id;    
            this.getCalendarContent(args.data.Id);
            this.$refs.calendarDialog.show();
             if (new Date(eventStart) < today) {
              this.e_calendar_buttons =  [ 
              {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false,  disabled: false}}];
              return;
          }
            this.e_calendar_buttons =  [
              {click: this.delCalendarOkClick, buttonModel: { content: '刪除', isPrimary: true,  disabled: this.limit.indexOf('12') < 0 }},
              {click: this.addCalendarOkClick, buttonModel: { content: '確認', isPrimary: true,  disabled: this.limit.indexOf('12') < 0 }}, 
              {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false,  disabled: false}}];
            return;
          }
          if (new Date(eventStart) < today) {
            args.cancel = true;
            this.$refs.toastRef.show( { title: '錯誤!', content: "無法新增今日以前的行事曆", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' })
            return;
          }
          // 新增
          this.e_edit_id = null;
          this.e_memo = '';
          this.totalL = 0;
          this.e_formula_id = null;
          this.e_import = 1;
          this.e_productionL = '';
          this.productvalue=[];
          this.selectedTexts = [];
          this.e_calendar_buttons =  [         
              {click: this.addCalendarOkClick, buttonModel: { content: '確認', isPrimary: true, disabled: this.limit.indexOf('12') < 0}}, 
              {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}];

          this.e_selected_date = this.getDate(args.data.startTime);
          this.$refs.calendarDialog.show();
        },
        onActionBegin: function (args) {  
    
          if (args.requestType === 'toolbarItemRendering') {
            let exportItem = {
              align: 'Right', showTextOn: 'Both', prefixIcon: 'e-icon-schedule-excel-export',
              text: '匯出', cssClass: 'e-excel-export', click: this.onExportClick.bind(this)
            };
            args.items.push(exportItem);
          }
        },
        onActionComplete(args) {
          if (args.requestType === 'eventChanged') {
                  args.changedRecords[0].StartTime = this.getDateTime(args.changedRecords[0].StartTime);
                  args.changedRecords[0].EndTime = this.getDateTime(args.changedRecords[0].EndTime);     
                  this.upData(args.changedRecords[0]);
          }
            this.getCalendar();
        },
        onExportClick: function () {
          let scheduleObj = this.$refs.ScheduleObj;
          scheduleObj.exportToExcel();    
        },
        onEventRendered: function (args) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const eventDate = new Date(args.data.StartTime);
                  let categoryColor = args.data.CategoryColor;
                  if (!args.element || !categoryColor) {
                    return;
                  }
          if (eventDate < today) {
            args.element.style.opacity = '0.5'; // 淡化外觀
            //  args.cancel = true;
            // args.element.style.draggable = false;   
            // args.element.style.pointerEvents = 'none'; // 不能點
          }

          if (this.$refs.ScheduleObj.ej2Instances.currentView === 'Agenda') {
            args.element.style.backgroundColor = '#FFFFFF';
            args.element.firstChild.style.borderLeftColor = categoryColor;
          } else {
            args.element.classList.add('custom-event-align-left');
            args.element.style.backgroundColor = categoryColor;
          }
          },    
        addCalendarOkClick: function() {  
          if (this.e_productionL == null || this.e_productionL == 0) {
           this.$refs.toastRef.show({ title: '警告!', content : `生產總量不得為0`, cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
           return; 
          }
      
          var all = this.selectedTexts.reduce((sum, item) => sum + (item.liter || 0), 0); 
      
          if ((all - (all *0.02) > this.e_productionL) || (all + (all *0.02) < this.e_productionL)) {
            this.$refs.toastRef.show({title: '警告!',content: `生產總量(${this.e_productionL}L)不得與配置總量(${all}L)差距過多`,cssClass: 'e-toast-warning',icon: 'e-warning toast-icons'});
            return;
          }
          const products = [];
          for (let i = 0; i < this.selectedTexts.length; i++) {
            const item = this.selectedTexts[i];
            if (this.selectedTexts[i].liter != null && this.selectedTexts[i].liter != 0)
            {
               const regex = new RegExp(item.value ?? '', 'g');
              const cleanedName = item?.text?.replace(regex, '').trim() || '';

              products.push({
                id: this.e_edit_id == null ? "1" :this.e_edit_id ,
                product_id: this.selectedTexts[i].value,
                product_name: cleanedName,
                liter: this.selectedTexts[i].liter,
                quity: this.selectedTexts[i].quity,
                orderby: this.selectedTexts[i].orderby
              });
            }           
          }   
          
          this.showLoading();
          this.axios({
              method: this.e_edit_id == null ? 'post' : 'put',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
              data : {
                schedure: 
                {
                  id : this.e_edit_id == null ? "1" :this.e_edit_id ,
                  formula_id : this.e_formula_id,
                  formula_name : this.formulalDatas.find(item => item.value === this.e_formula_id)?.text.replace(this.e_formula_id, '').trim() || '',
                  cookie_l : this.e_productionL,
                  memo : this.e_memo,
                  date : this.e_selected_date,
                  import : this.e_import 
                },
                products : products
              }
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading();  return; }              
            this.showMsg( this.e_edit_id == null ? '新增成功!' : '修改成功!');         
            this.$refs.calendarDialog.hide();
            this.hideLoading();
            this.getCalendar();  
          
          })
          .catch((error) => {
            this.showError(error, true) }
          )    
        },
        upData: function (args) {        
          // console.log("換位置:",args)
          this.upDateTime(args)
        },
        delCalendarOkClick: function() {       
          DialogObj = DialogUtility.confirm({
            title: '資料刪除',
            content: `確認是否要刪除資料嗎?`,
            okButton: {  text: '確認', click: this.delFormulaOkConfirmClick },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
          });          
        },
        delFormulaOkConfirmClick:function(){
          this.showLoading();    
          this.axios({
            method: 'delete',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: 'Calendar',
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data : { id: this.e_edit_id }
          })
          .then((response) => {                
            this.hideLoading();
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });  DialogObj.hide(); return; }    
              this.$toast.open({message: "資料已刪除", type: "success", duration: 5000, dismissible: true})   
              this.$refs.calendarDialog.hide();
              DialogObj.hide(); 
              this.getCalendar();
            })
            .catch((error) => { this.showError(error) }
          )
        },
        // ok
        getCalendar: function () { 
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
            
            const transformedData = response.data.datas.map(event => ({
              Id: event.id, // 改成 Schedule 預設的 Id 欄位
              Subject: event.subject,
              StartTime: new Date(event.starttime),
              EndTime: new Date(event.endtime),
              CategoryColor: event.categorycolor,
              IsAllDay: true
            }));
            console.log("transformedData:",transformedData)
            this.eventSettings = { dataSource: transformedData }
          })
          .catch((error) => { 
            this.showError(error, true) }
          )             
        },
        getCalendarAgenda: function () { 
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar/Agenda`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
            
            const transformedData = response.data.datas.map(event => ({
              Id: event.id, // 改成 Schedule 預設的 Id 欄位
              Subject: event.subject,
              StartTime: new Date(event.starttime),
              EndTime: new Date(event.endtime),
              CategoryColor: event.categorycolor,
              IsAllDay: true
            }));
            this.eventSettings = { dataSource: transformedData }
          })
          .catch((error) => { 
            this.showError(error, true) }
          )             
        },
        getCalendarContent: function (id) { 
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar/Content?calendar_id=${id}`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }             
            console.log("抓取資料:",response.data.datas);    
            this.e_memo           = response.data.datas.schedure.memo;
            this.e_formula_id     = response.data.datas.schedure.formula_id;
            this.e_productionL    = response.data.datas.schedure.cookie_l;
            this.e_selected_date  = response.data.datas.schedure.date;
            this.e_import         = response.data.datas.schedure.import;
            this.totalL           = response.data.datas.products.reduce((sum, item) => sum + (item.liter || 0), 0);
            const transformedData = response.data.datas.products.map(event => ({
              text: `${event.product_id} ${event.product_name}`, 
              value: event.product_id,
              liter: event.liter,
              quity: event.quity,
              param: event.param,
              orderby: event.orderby
            }));
            this.onFormulalChange().then(() => {
            this.$nextTick(() => {
              // this.$refs.multiselect.ej2Instances.refresh();
              const DropDownListData = response.data.datas.products.map(event => event.product_id);
              this.productvalue =DropDownListData;
              this.$nextTick(() => {
                this.selectedTexts = transformedData;
              });
            });
          });
            //   this.$refs.multiselect.ej2Instances.value.push()
          })
          .catch((error) => { 
            this.showError(error, true) } 
          )    
        },
        // ok
        getFormula: function () {  // 取得配方
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Calendar/Formula`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
            this.formulalDatas = response.data.datas   
          })
          .catch((error) => { 
            this.showError(error, true) }
          )             
        },
        showError: function (error) {     
          this.hideLoading();
          if (error.response.status == 400) {
            for(var key in error.response.data.errors){      
              this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
            }
            return;
          }   
          if (error.response.status == 401) {
            localStorage.removeItem('token'); this.$router.push('/login');
            return;
          }
          this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        },
        showMsg: function (msg) {
          this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
        },
        showLoading() {
          Loader = this.$loading.show({
            container: this.$refs.loadingContainer,
            canCancel: true, // default false
            onCancel: this.yourCallbackMethod,
            color: 'red',
            loader: 'dots',  // spinner, dots, bars
            width: 164,
            height: 164,
            backgroundColor: 'black',
            opacity: 0.5,
            zIndex: 999,
          });
        },
        hideLoading() {
            Loader.hide();
        }
      
      },
      created() {        
        this.getCalendar();
        this.getFormula();
        this.onFormulalChange('all');
      },
      
      provide: {
        schedule: [Day, Week, TimelineViews, Month, Agenda, Resize, DragAndDrop, ExcelExport]
      }
    }
    </script>
    <style lang="scss" src="../../scss/base.scss"></style>
    <style scoped>

    .schedule-vue-sample .header-customization {
        padding-bottom: 10px;
    }

    .schedule-vue-sample .property-customization {
        padding-right: 5px;
    }

    .schedule-vue-sample .button-customization {
        padding: 15px;
    }

    @media (max-width: 441px){
        .schedule-vue-sample .button-customization {
            padding: 30px;
        }
    }
</style>